import React from 'react';
import { motion } from 'framer-motion';
import successStory1 from '../assets/images/success-story-1.png';
import successStory2 from '../assets/images/success-story-2.png';
import successStory3 from '../assets/images/success-story-3.png';
import successStory4 from '../assets/images/success-story-4.png';
import successStory5 from '../assets/images/success-story-5.png';
import successStory6 from '../assets/images/success-story-6.png';

const testimonials = [
  {
    name: "Sarah Ahmed",
    role: "BBA Student",
    university: "NORTH SOUTH UNIVERSITY",
    quote: "The VIP community gave me access to mentors who helped me launch my first startup. I couldn't have done it without their guidance.",
    image: successStory1
  },
  {
    name: "Tanvir Hasan",
    role: "CSE Student",
    university: "BRAC UNIVERSITY",
    quote: "Through the networking events, I secured an internship at a top tech firm. The skills I learned here were invaluable.",
    image: successStory2
  },
  {
    name: "Nusrat Jahan",
    role: "Economics Major",
    university: "DHAKA UNIVERSITY",
    quote: "The scholarship guidance I received was a game-changer. I'm now pursuing my dream degree with full funding.",
    image: successStory3
  },
  {
    name: "Rahim Uddin",
    role: "EEE Student",
    university: "BUET",
    quote: "The technical workshops helped me master skills that aren't taught in class. It gave me a huge advantage in my career.",
    image: successStory4
  },
  {
    name: "Rahi Anika",
    role: "Law Student",
    university: "INDEPENDENT UNIVERSITY",
    quote: "I found a supportive community that pushed me to excel. The leadership opportunities have boosted my confidence immensely.",
    image: successStory5
  },
  {
    name: "Nur A Alom Fahim",
    role: "Statistics Topper",
    university: "Jagannath UNIVERSITY",
    quote: "The 1-on-1 reviews helped me refine my portfolio. I'm now confident in applying to international firms.",
    image: successStory6
  }
];

const SuccessStories = () => {
  return (
    <section className="py-20 bg-rich-black" id="success-stories">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Success Stories
          </h2>
          <p className="text-xl text-medium-gray max-w-2xl mx-auto">
            Hear from our students who have transformed their careers and lives.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 overflow-hidden">
          {testimonials.map((testimonial, index) => (
            <motion.div 
              key={index}
              initial={{ 
                opacity: 0, 
                x: index % 2 === 0 ? -100 : 100 
              }}
              whileInView={{ 
                opacity: 1, 
                x: 0 
              }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ 
                duration: 0.8, 
                ease: "easeOut",
                delay: index * 0.15
              }}
              className="flex flex-col sm:flex-row bg-dark-charcoal rounded-2xl overflow-hidden border border-white/10 hover:border-vibrant-red/50 transition-colors duration-300 hover:shadow-glow group"
            >
              <div className="sm:w-2/5 h-64 sm:h-auto relative overflow-hidden">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name} 
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent sm:bg-gradient-to-r sm:from-transparent sm:to-black/60"></div>
              </div>
              <div className="sm:w-3/5 p-6 flex flex-col justify-center relative">
                <h3 className="text-vibrant-red font-bold text-sm tracking-wider mb-3 uppercase">
                  {testimonial.university}
                </h3>
                <blockquote className="text-white italic mb-4 relative z-10">
                  "{testimonial.quote}"
                </blockquote>
                <div className="mt-auto">
                  <p className="text-white font-bold text-lg">{testimonial.name}</p>
                  <p className="text-medium-gray text-sm">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;
